import { getEnv } from "../../utils/getEnv";
import { fetchWithToken } from "../../platform-core";
import { CORE_BFF_BASE_URL } from "../../utils/constants";

export async function submitErrorLog(
  clientId: string | undefined,
  userId: string | undefined,
  comment: string | undefined,
  correlationId: string | undefined,
  component: string | undefined,
  componentStack: string | undefined,
  exceptionInformation: string | undefined,
  commandInformation: string | undefined
): Promise<Response> {
  const URL = `${CORE_BFF_BASE_URL}/v1/error-reporting`;
  return await fetchWithToken(`${URL}`, {
    method: "POST",
    body: JSON.stringify({
      ClientId: clientId,
      UserId: userId,
      Comment: comment,
      CorrelationId: correlationId,
      Component: component,
      ComponentStack: componentStack?.replace(/\n|\r/g, ""),
      ExceptionInformation: exceptionInformation?.replace(/\n|\r/g, ""),
      CommandInformation: commandInformation,
    }),
  });
}
